// extracted by mini-css-extract-plugin
module.exports = {"light":"pulse_light__yOqwL","dark":"pulse_dark___58_Z"};